<template>
  <div class="nav-right-expand-search" id="">
    <div class="hidden-sm hidden-xs">
      <div class="navbar navbar-inverse" role="navigation">
        <header data-collapsible="" id="desktop-header">
          <div class="container">
            <div class="header-wrapper clearfix">
              <div id="desktop-logo">
                <a href="#"
                  ><img
                    alt="Dealership"
                    class="dealer-logo"
                    :src="[!logoURL ? images.logoExample[0] : logoURL]"
                    title="Dealership"
                /></a>
              </div>
              <ul
                class="navbar-nav"
                data-more-dropdown=""
                id="desktop-menu"
                role="menubar"
              >
                <li role="none">
                  <a href="#" role="menuitem" target="">Home</a>
                </li>
                <li
                  class="dropdown"
                  role="none"
                  @mouseenter="addOpen"
                  @mouseleave="removeOpen"
                >
                  <a
                    aria-expanded="false"
                    aria-haspopup="true"
                    class="dropdown-toggle"
                    data-hover="dropdown"
                    data-model-dropdown=""
                    data-section-title="New Vehicles"
                    data-toggle="dropdown"
                    href="#"
                    role="menuitem"
                    target=""
                    >New Vehicles</a
                  >
                  <ul
                    aria-label="New Vehicles"
                    class="dropdown-menu"
                    role="menu"
                  >
                    <li role="none">
                      <a href="#" role="menuitem" target="">Browse Inventory</a>
                    </li>
                    <li role="none">
                      <a href="#" role="menuitem" target=""
                        >Schedule Test Drive</a
                      >
                    </li>
                    <li role="none">
                      <a href="#" role="menuitem" target="">Quick Quote</a>
                    </li>
                    <li role="none">
                      <a href="#" role="menuitem" target=""
                        >Trade In Evaluation</a
                      >
                    </li>
                    <li role="none">
                      <a href="#" role="menuitem" target="">Shop Our Ads</a>
                    </li>
                  </ul>
                </li>
                <li
                  class="dropdown"
                  role="none"
                  @mouseenter="addOpen"
                  @mouseleave="removeOpen"
                >
                  <a
                    aria-expanded="false"
                    aria-haspopup="true"
                    class="dropdown-toggle"
                    data-hover="dropdown"
                    data-model-dropdown=""
                    data-section-title="Pre-Owned Vehicles"
                    data-toggle="dropdown"
                    href="#"
                    role="menuitem"
                    target=""
                    >Pre-Owned Vehicles</a
                  >
                  <ul
                    aria-label="Pre-Owned Vehicles"
                    class="dropdown-menu"
                    role="menu"
                  >
                    <li role="none">
                      <a href="#" role="menuitem" target="">Browse Inventory</a>
                    </li>
                    <li role="none">
                      <a href="#" role="menuitem" target=""
                        >Vehicles Under $12,000</a
                      >
                    </li>
                    <li role="none">
                      <a href="#" role="menuitem" target=""
                        >Locate Your Vehicle</a
                      >
                    </li>
                    <li role="none">
                      <a href="#" role="menuitem" target=""
                        >Trade In Evaluation</a
                      >
                    </li>
                  </ul>
                </li>
                <li
                  class="dropdown"
                  role="none"
                  @mouseenter="addOpen"
                  @mouseleave="removeOpen"
                >
                  <a
                    aria-expanded="false"
                    aria-haspopup="true"
                    class="dropdown-toggle"
                    data-hover="dropdown"
                    data-model-dropdown=""
                    data-section-title="Specials"
                    data-toggle="dropdown"
                    href="#"
                    role="menuitem"
                    target=""
                    >Specials</a
                  >
                  <ul aria-label="Specials" class="dropdown-menu" role="menu">
                    <li role="none">
                      <a href="#" role="menuitem" target=""
                        >New Vehicle Specials</a
                      >
                    </li>
                    <li role="none">
                      <a href="#" role="menuitem" target=""
                        >Pre-Owned Specials</a
                      >
                    </li>
                  </ul>
                </li>
                <li
                  class="dropdown"
                  role="none"
                  @mouseenter="addOpen"
                  @mouseleave="removeOpen"
                >
                  <a
                    aria-expanded="false"
                    aria-haspopup="true"
                    class="dropdown-toggle"
                    data-hover="dropdown"
                    data-model-dropdown=""
                    data-section-title="Financing"
                    data-toggle="dropdown"
                    href="#"
                    role="menuitem"
                    target=""
                    >Financing</a
                  >
                  <ul aria-label="Financing" class="dropdown-menu" role="menu">
                    <li role="none">
                      <a href="#" role="menuitem" target=""
                        >Finance Information</a
                      >
                    </li>
                    <li role="none">
                      <a href="#" role="menuitem" target=""
                        >Finance Application</a
                      >
                    </li>
                  </ul>
                </li>
                <li
                  class="dropdown"
                  role="none"
                  @mouseenter="addOpen"
                  @mouseleave="removeOpen"
                >
                  <a
                    aria-expanded="false"
                    aria-haspopup="true"
                    class="dropdown-toggle"
                    data-hover="dropdown"
                    data-model-dropdown=""
                    data-section-title="Service &amp; Parts"
                    data-toggle="dropdown"
                    href="#"
                    role="menuitem"
                    target=""
                    >Service &amp; Parts</a
                  >
                  <ul
                    aria-label="Service &amp; Parts"
                    class="dropdown-menu"
                    role="menu"
                  >
                    <li role="none">
                      <a href="#" role="menuitem" target="">Service Info</a>
                    </li>
                    <li role="none">
                      <a href="#" role="menuitem" target=""
                        >Service Appointments</a
                      >
                    </li>
                    <li role="none">
                      <a href="#" role="menuitem" target="">Service Coupons</a>
                    </li>
                    <li role="none">
                      <a href="#" role="menuitem" target="">Parts Request</a>
                    </li>
                  </ul>
                </li>
                <li
                  class="dropdown"
                  role="none"
                  @mouseenter="addOpen"
                  @mouseleave="removeOpen"
                >
                  <a
                    aria-expanded="false"
                    aria-haspopup="true"
                    class="dropdown-toggle"
                    data-hover="dropdown"
                    data-model-dropdown=""
                    data-section-title="About"
                    data-toggle="dropdown"
                    href="#"
                    role="menuitem"
                    target=""
                    >About</a
                  >
                  <ul aria-label="About" class="dropdown-menu" role="menu">
                    <li role="none">
                      <a href="#" role="menuitem" target="">Reviews</a>
                    </li>
                    <li role="none">
                      <a href="#" role="menuitem" target=""
                        >Career Opportunities</a
                      >
                    </li>
                    <li role="none">
                      <a href="#" role="menuitem" target="">Staff Directory</a>
                    </li>
                  </ul>
                </li>
                <li>
                  <a class="dropdown-toggle" data-hover="dropdown" data-model-dropdown="" data-toggle="dropdown" role="menuitem" aria-label="search">
                    <i aria-hidden="true" class="fa fa-search"></i>
                  </a>
                  <div id="dropdown-search" class="dropdown-menu" role="menu">
                    <div class="container">
                      <div class="search-bar">
                        <form action="/vehicles" role="search">
                          <div class="input-group">
                            <input
                              aria-label="Search Bar"
                              autocomplete="off"
                              autocorrect="off"
                              class="form-control input-search"
                              data-custom="false"
                              data-placement="bottom"
                              data-search-suggestions="true"
                              data-suggest="true"
                              data-top="Search this site..."
                              name="query"
                              placeholder="Search this site..."
                              spellcheck="false"
                              title="Search this site..."
                              type="text"
                              value=""
                            />
                            <span class="input-group-btn">
                              <button
                                aria-label="search text"
                                class="btn btn-default no-border-left"
                                type="submit"
                              >
                                <i
                                  aria-hidden="true"
                                  class="fa fa-search"
                                ></i>
                              </button>
                            </span>
                          </div>
                        </form>
                      </div>
                    </div>
                  </div>
                </li>
              </ul>
            </div>
          </div>
        </header>
      </div>
    </div>
    <div class="visible-sm visible-xs">
      <div class="mobile-contact-bar navbar">
        <div class="toggle-side-menu">
          <a class="mobile-menu-toggle" @click="toggleSideNav">
            <span class="icon-label">MENU</span>
            <span class="icon-bar"></span>
            <span class="icon-bar"></span>
            <span class="icon-bar"></span>
          </a>
        </div>
        <div class="mobile-dealer-logo pull-left">
          <a href="#">
            <img alt="Logo" class="dealer-logo"
            :src="[!logoURL ? images.logoExample[0] : logoURL]"
              title="Logo">
          </a>
        </div>
        <div class="contact-info">
          <div class="contact-item mobile-sales-phone" id="toggle-click-to-call">
            <i class="fa fa-phone"></i>
            <a class="hidden-xs" href="#"></a>
          </div>
          <a class="contact-item mobile-get-directions"
            data-action="Address Click" data-category="Hours &amp; Directions" data-label="Dealership Address Link"
            href="#" itemprop="hasMap">
            <i aria-hidden="true" class="fa fa-map-marker"></i>
            <span class="hidden-xs">Directions</span>
          </a>
        </div>
      </div>
      <div class="mobile-nav-bar sidr left" id="sidr" role="navigation" style="transition: left 0.2s ease 0s;" v-if="sideNavOpen">
        <div class="navbar-inner nav navbar-nav">
          <ul class="side-nav" role="menu">
            <div class="search-bar">
              <form action="/vehicles" role="search">
                <div class="input-group">
                  <input aria-label="Search Bar" autocomplete="off" autocorrect="off" class="form-control input-search" data-custom="false" data-placement="bottom" data-search-suggestions="true" data-suggest="true" data-top="" name="query" placeholder="Search this site..." spellcheck="false" title="Search this site..." type="text" value="">
                  <span class="input-group-btn">
                    <button aria-label="search text" class="btn btn-default no-border-left" type="submit">
                      <i aria-hidden="true" class="fa fa-search"></i>
                    </button>
                  </span>
                </div>
              </form>
            </div>
            <li role="none">
              <a href="#" role="menuitem" target="">Home</a>
            </li>
            <li class="dropdown" role="none">
              <a role="button" data-toggle="collapse" href="#new-vehicles" aria-expanded="false" aria-controls="new-vehicles">New Vehicles</a>
              <ul id="new-vehicles" aria-label="New Vehicles" class="collapse" role="menu">
                <li role="none"><a href="#" role="menuitem" target="">Browse Inventory</a></li>
                <li role="none"><a href="#" role="menuitem" target="">Schedule Test Drive</a></li>
                <li role="none"><a href="#" role="menuitem" target="">Quick Quote</a></li>
                <li role="none"><a href="#" role="menuitem" target="">Trade In Evaluation</a></li>
                <li role="none"><a href="#" role="menuitem" target="">Shop Our Ads</a></li>
              </ul>
            </li>
            <li class="dropdown" role="none">
              <a role="button" data-toggle="collapse" href="#pre-owned-vehicles" aria-expanded="false" aria-controls="pre-owned-vehicles">Pre-Owned Vehicles</a>
              <ul id="pre-owned-vehicles" aria-label="Pre-Owned Vehicles" class="collapse" role="menu">
                <li role="none"><a href="#" role="menuitem" target="">Browse Inventory</a></li>
                <li role="none"><a href="#" role="menuitem" target="">Vehicles Under $12,000</a></li>
                <li role="none"><a href="#" role="menuitem" target="">Locate Your Vehicle</a>
                </li>
                <li role="none"><a href="#" role="menuitem" target="">Trade In Evaluation</a></li>
              </ul>
            </li>
            <li class="dropdown" role="none">
              <a role="button" data-toggle="collapse" href="#specials" aria-expanded="false" aria-controls="specials">Specials</a>
              <ul id="specials" aria-label="Specials" class="collapse" role="menu">
                <li role="none"><a href="#" role="menuitem" target="">New Vehicle Specials</a></li>
                <li role="none"><a href="#" role="menuitem" target="">Pre-Owned Specials</a></li>
              </ul>
            </li>
            <li class="dropdown" role="none">
              <a role="button" data-toggle="collapse" href="#financing" aria-expanded="false" aria-controls="financing">Financing</a>
              <ul id="financing" aria-label="Financing" class="collapse" role="menu">
                <li role="none"><a href="#" role="menuitem" target="">Finance Information</a></li>
                <li role="none"><a href="#" role="menuitem" target="">Finance Application</a></li>
              </ul>
            </li>
            <li class="dropdown" role="none">
              <a role="button" data-toggle="collapse" href="#service" aria-expanded="false" aria-controls="service">Service &amp; Parts</a>
              <ul id="service" aria-label="Service &amp; Parts" class="collapse" role="menu">
                <li role="none"><a href="#" role="menuitem" target="">Service Info</a></li>
                <li role="none"><a href="#" role="menuitem" target="">Service Appointments</a></li>
                <li role="none"><a href="#" role="menuitem" target="">Service Coupons</a></li>
                <li role="none"><a href="#" role="menuitem" target="">Parts Request</a></li>
              </ul>
            </li>
            <li class="dropdown" role="none">
              <a role="button" data-toggle="collapse" href="#about" aria-expanded="false" aria-controls="about">About</a>
              <ul id="about" aria-label="About" class="collapse" role="menu">
                <li role="none"><a href="#" role="menuitem" target="">Reviews</a></li>
                <li role="none"><a href="#" role="menuitem" target="">Career Opportunities</a></li>
                <li role="none"><a href="#" role="menuitem" target="">Staff Directory</a></li>
              </ul>
            </li>
            <div class="close-mobile-wrap" @click="closeSideNav">
              <span class="close-mobile-nav">
                <i class="fa fa-close">&nbsp;</i>
                <span>close</span>
              </span>
            </div>
          </ul>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: ['images', 'logoURL'],
  data() {
    return {
      sideNavOpen: false,
    };
  },
  mounted() {},
  methods: {
    addOpen: function(e) {
      e.target.classList.add("open");
    },
    removeOpen: function(e) {
      e.target.classList.remove("open");
    },
    toggleSideNav: function() {
      this.sideNavOpen = !this.sideNavOpen;
    },
    closeSideNav: function() {
      this.sideNavOpen = false;
    },
  },
};
</script>

<style
  scoped
  src="../../static/bootstrap-3.3.7-dist/css/bootstrap.min.css"
></style>

<style scoped>
.nav-right-expand-search .dealer-logo {
  max-width: 280px;
  max-height: 70px;
}
.nav-right-expand-search .navbar {
  margin-bottom: 0;
  border-radius: 0;
  border: none;
}
.nav-right-expand-search header {
  background-color: var(--primary-light);
  font-size: 15px;
  font-weight: 400;
  -webkit-box-shadow: 0 4px 5px 0 rgba(0, 0, 0, 0.14),
    0 1px 10px 0 rgba(0, 0, 0, 0.12), 0 2px 4px -1px rgba(0, 0, 0, 0.16);
  box-shadow: 0 4px 5px 0 rgba(0, 0, 0, 0.14), 0 1px 10px 0 rgba(0, 0, 0, 0.12),
    0 2px 4px -1px rgba(0, 0, 0, 0.16);
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}
.nav-right-expand-search header > .container {
  position: static;
}
.nav-right-expand-search header .container .header-wrapper {
  white-space: nowrap;
  display: flex;
  justify-content: space-between;
  flex-direction: row;
  align-items: center;
}
.nav-right-expand-search header .container .header-wrapper #desktop-logo {
  display: inline-block;
  padding-right: 30px;
  vertical-align: middle;
}
.nav-right-expand-search header .container .header-wrapper ul {
  margin: 0;
  border: none;
  border-radius: 0;
  padding: 0;
}
.nav-right-expand-search header .container .header-wrapper #desktop-menu {
  display: inline-block;
  float: none;
  vertical-align: middle;
}
.nav-right-expand-search header .container .header-wrapper #desktop-menu > li {
  display: inline-block;
  vertical-align: top;
  background: transparent;
}
.nav-right-expand-search header .container .header-wrapper #desktop-menu
  > li > a {
  display: block;
  padding: 10px 12px;
  line-height: 28px;
  text-decoration: none;
  font-weight: 500;
  color: var(--primary-dark);
  cursor: pointer;
}
.nav-right-expand-search header .container .header-wrapper #desktop-menu
  > li > a:hover, .nav-right-expand-search header .container .header-wrapper #desktop-menu > .open > a {
  color: var(--primary-dark);
  background: transparent;
}
.nav-right-expand-search header .navbar-nav > li .dropdown-menu > li a {
  padding: 6px 15px;
}
#dropdown-search {
  background-color: var(--secondary-light);
  width: 100%;
}
#dropdown-search .search-bar .input-search, #dropdown-search .search-bar button {
  height: 40px;
  font-size: 16px;
}
#dropdown-search .search-bar .input-search {
  border-top-right-radius: 0px !important;
  border-bottom-right-radius: 0px !important;
}
#dropdown-search .search-bar button {
  border-top-left-radius: 0px !important;
  border-bottom-left-radius: 0px !important;
}
.nav-right-expand-search header .container .header-wrapper #desktop-menu
  .search-bar {
  padding-top: 0;
}
.mobile-contact-bar {
  height: 70px;
  background: #fff;
  left: 0;
  top: 0;
  width: 100%;
}
.mobile-contact-bar .mobile-dealer-logo img {
  padding: 10px;
}
.mobile-contact-bar .mobile-menu-toggle {
  width: 60px;
  height: 70px;
  padding: 25px 15px;
  float: left;
  background: transparent;
}
.mobile-contact-bar .mobile-menu-toggle .icon-bar {
  display: block;
  margin-top: 4px;
  width: 30px;
  height: 3px;
  border-radius: 1px;
  background-color: var(--primary-color);
}
.mobile-contact-bar .mobile-menu-toggle .icon-label {
  display: none;
}
.mobile-contact-bar .contact-info {
  float: right;
  margin-top: 1.6em;
  margin-right: 1.2em;
}
.mobile-contact-bar .contact-info .contact-item {
  display: inline-block;
  vertical-align: middle;
  color: var(--primary-color);
  font-size: 1.7em;
  letter-spacing: 0.05em;
  margin-right: 0.7em;
  font-weight: 600;
}
.mobile-contact-bar .contact-info .contact-item:hover {
  text-decoration: none;
  cursor: pointer;
}
.mobile-contact-bar .contact-info .contact-item .fa {
  margin-right: 0.1em;
}
.mobile-contact-bar .contact-info .contact-item a {
  color: inherit;
}
.mobile-contact-bar .contact-info .contact-item a:hover {
  text-decoration: inherit;
}
.mobile-nav-bar .side-nav {
  border-bottom: none;
}
.mobile-nav-bar .search-bar {
  border: 1px solid #4d4d4d;
}
.mobile-nav-bar .search-bar form {
  margin: 0;
}
.mobile-nav-bar .search-bar .input-search {
  margin: 0;
  padding: 5;
  height: 40px;
}
.mobile-nav-bar .search-bar .input-group-btn {
  padding: 0;
}
.mobile-nav-bar .search-bar .input-group-btn button {
  height: 40px;
}
.mobile-nav-bar .side-nav > li {
  display: block;
  float: left;
  width: 100%;
  border-bottom: 1px solid #333;
}
.mobile-nav-bar .side-nav > li > a,
.mobile-nav-bar .navbar-inner > ul > li.dropdown.open > a {
  background: #222;
  color: #fff;
  display: block;
  height: 40px;
  font-size: 14px;
  line-height: 20px;
  padding: 10px 15px;
  color: #fff;
  white-space: nowrap;
  font-size: 14px;
  font-weight: normal;
  text-align: left;
  text-transform: none;
  margin: 0;
}
.mobile-nav-bar .side-nav > li > a:hover,
.mobile-nav-bar .navbar-inner > ul > li.dropdown.open > a:hover {
  background: #1c1c1c;
}
.mobile-nav-bar .side-nav > li > ul.dropdown-menu > li > a {
  height: 40px;
  line-height: 40px;
  background: #444;
  font-size: 14px;
  color: #fff;
  text-align: left;
  float: left;
  min-width: 100%;
  position: relative;
  border-bottom: 1px solid #333;
}
.mobile-nav-bar .side-nav > li > ul.dropdown-menu > li > a:hover {
  background: #333;
}
.mobile-nav-bar .close-mobile-wrap {
  text-align: right;
  padding: 10px 15px;
}
.mobile-nav-bar .close-mobile-wrap .close-mobile-nav {
  color: #aaa;
}
.mobile-nav-bar .close-mobile-wrap .close-mobile-nav:hover {
  cursor: pointer;
  color: #fff;
}

@media (min-width: 1501px) {
  .nav-right-expand-search header > .container {
    width: 85%;
    min-width: 1170px;
  }
  .nav-right-expand-search .header-wrapper {
    margin: auto;
    width: fit-content;
  }
}

@media (max-width: 1500px) {
  .nav-right-expand-search header > .container {
    width: 100% !important;
  }
}

@media (min-width: 1201px) {
  .nav-right-expand-search .navigation_with_contact {
    box-shadow: none;
  }
  .nav-right-expand-search header > .container {
    max-width: 1185px;
  }
}

@media (max-width: 1200px) and (min-width: 768px) {
  .nav-right-expand-search .nav-height {
    height: 70px;
  }
  .nav-right-expand-search .hidden-sm {
    display: none !important;
  }
  .nav-right-expand-search .visible-sm {
    display: block !important;
  }
  .nav-right-expand-search .mobile-dealer-logo .dealer-logo {
    max-height: 70px;
  }
}

@media (max-width: 767px) {
  .nav-right-expand-search .sub-navigation-vehicle-search .search-form
    .search-form-option {
    max-width: 80px;
  }
  .nav-right-expand-search .mobile-dealer-logo .dealer-logo {
    max-height: 55px;
  }
  .nav-right-expand-search .mobile-contact-bar {
    height: 55px;
  }
  .nav-right-expand-search .mobile-contact-bar .mobile-menu-toggle {
    height: 55px;
    padding: 15px;
    cursor: pointer;
  }
  .nav-right-expand-search .mobile-contact-bar .contact-info {
    margin-top: 0.8em;
    margin-right: 0;
  }
  .nav-right-expand-search .mobile-contact-bar .contact-info .contact-item {
    font-size: 2.4em;
  }
  .nav-right-expand-search .side-nav .open .dropdown-menu > li > a {
    padding: 0 25px 0 !important;
  }
}

@media (max-width: 480px) {
  .nav-right-expand-search .mobile-dealer-logo .dealer-logo {
    max-width: 230px;
  }
}

@media (max-width: 400px) {
  .nav-right-expand-search .mobile-dealer-logo .dealer-logo {
    max-width: 145px;
  }
}

.mobile-contact-bar {
  height: 70px;
  background: #fff;
  position: relative;
  left: 0;
  top: 0;
  width: 100%;
  }
  .mobile-contact-bar .mobile-dealer-logo img {
  padding: 10px;
  }
  .mobile-contact-bar .mobile-menu-toggle {
  width: 60px;
  height: 70px;
  padding: 25px 15px;
  float: left;
  background: transparent;
  cursor: pointer;
  }
  .mobile-contact-bar .mobile-menu-toggle .icon-bar {
  display: block;
  margin-top: 4px;
  width: 30px;
  height: 3px;
  border-radius: 1px;
  background-color: var(--primary-color);
  }
  .mobile-contact-bar .mobile-menu-toggle .icon-label {
  display: none;
  }
  .mobile-contact-bar .contact-info {
  float: right;
  margin-top: 1.6em;
  margin-right: 1.2em;
  }
  .mobile-contact-bar .contact-info .contact-item {
  display: inline-block;
  vertical-align: middle;
  color: var(--primary-color);
  font-size: 1.7em;
  letter-spacing: .05em;
  margin-right: .7em;
  }
  .mobile-contact-bar .contact-info .contact-item:hover {
  text-decoration: none;
  cursor: pointer;
  }
  .mobile-contact-bar .contact-info .contact-item .fa {
  margin-right: .1em;
  }
  .mobile-contact-bar .contact-info .contact-item a {
  color: inherit;
  }
  .mobile-contact-bar .contact-info .contact-item a:hover {
  text-decoration: inherit;
  }
  .mobile-nav-bar .side-nav {
  border-bottom: none;
  }
  .mobile-nav-bar .search-bar {
  border: 1px solid #4d4d4d;
  }
  .mobile-nav-bar .search-bar form {
  margin: 0;
  }
  .mobile-nav-bar .search-bar .input-search {
  margin: 0;
  height: 40px;
  }
  .mobile-nav-bar .search-bar .input-group-btn {
  padding: 0;
  }
  .mobile-nav-bar .search-bar .input-group-btn button {
  height: 40px;
  }
  .mobile-nav-bar .side-nav > li {
  display: block;
  float: left;
  width: 100%;
  border-bottom: 1px solid #333;
  }
  .mobile-nav-bar .side-nav > li > a, .mobile-nav-bar .navbar-inner > ul > li.dropdown > a {
  background: #222;
  color: #fff;
  display: block;
  height: 40px;
  font-size: 14px;
  line-height: 20px;
  padding: 10px 15px;
  color: #fff;
  white-space: nowrap;
  font-size: 14px;
  font-weight: normal;
  text-align: left;
  text-transform: none;
  margin: 0;
  }
  .mobile-nav-bar .side-nav > li > a:hover, .mobile-nav-bar .navbar-inner > ul > li.dropdown > a:hover {
  background: #1c1c1c;
  }
  .mobile-nav-bar .side-nav > li > ul {
  width: 100%;
  left: 0;
  position: relative;
  list-style: none;
  }
  .mobile-nav-bar .side-nav > li > ul > li > a {
  height: 40px;
  line-height: 40px;
  background: #444;
  font-size: 14px;
  color: #fff;
  text-align: left;
  float: left;
  min-width: 100%;
  position: relative;
  border-bottom: 1px solid #333;
  padding-left: 30px;
  }
  .mobile-nav-bar .side-nav > li > ul > li > a:hover {
  background: #333;
  }
  .mobile-nav-bar .close-mobile-wrap {
  text-align: right;
  padding: 10px 15px;
  }
  .mobile-nav-bar .close-mobile-wrap .close-mobile-nav {
  color: #aaa;
  }
  .mobile-nav-bar .close-mobile-wrap .close-mobile-nav:hover {
  cursor: pointer;
  color: #fff;
  }
  .sidr {
    position: absolute;
    z-index: 20;
    top: 70px;
    height: 100%;
    min-height: 600px;
    width: 260px;
    overflow-x: hidden;
    overflow-y: auto;
    font-size: 15px;
    background: #333;
    color: #fff;
    box-shadow: 0 0 5px 5px #222 inset;
  }
  .sidr .input-search {
    width: 100%;
    font-size: 13px;
    padding: 5px;
    -moz-box-sizing: border-box;
    -webkit-box-sizing: border-box;
    box-sizing: border-box;
    margin: 0 0 10px;
    border-radius: 2px;
    border: 0;
    background: rgba(0,0,0,0.1);
    color: rgba(255,255,255,0.6);
    clear: both;
  }
  .sidr ul {
    padding: 0;
    border-top: 1px solid #1a1a1a;
    border-bottom: 1px solid #4d4d4d;
    top: 100%;
    float: left;
    min-width: 160px;
    font-size: 14px;
    text-align: left;
    list-style: none;
    background-clip: padding-box;
    border: 1px solid rgba(0,0,0,0.15);
    border-radius: 4px;
  }
  .sidr ul li {
    margin: 0;
    line-height: 48px;
    border-top: 1px solid #4d4d4d;
    border-bottom: 1px solid #1a1a1a;
  }

  @media (max-width: 767px) {
    .sidr {
      top: 55px;
    }
  }
</style>
